var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70711 9.68953C8.31658 10.0801 7.68342 10.0801 7.29289 9.68953L0.292893 2.68953C-0.0976315 2.299 -0.0976315 1.66584 0.292893 1.27532C0.683417 0.88479 1.31658 0.88479 1.70711 1.27532L8 7.56821L14.2929 1.27532C14.6834 0.88479 15.3166 0.88479 15.7071 1.27532C16.0976 1.66584 16.0976 2.299 15.7071 2.68953L8.70711 9.68953Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/icArrowDown.ac46bc4eefa150c2ba0119b40044da50.svg";
export { ForwardRef as ReactComponent };